import { render, staticRenderFns } from "./PasswordView.vue?vue&type=template&id=37537616&"
import script from "./PasswordView.vue?vue&type=script&lang=js&"
export * from "./PasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37537616')) {
      api.createRecord('37537616', component.options)
    } else {
      api.reload('37537616', component.options)
    }
    module.hot.accept("./PasswordView.vue?vue&type=template&id=37537616&", function () {
      api.rerender('37537616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/common/PasswordView.vue"
export default component.exports